module.exports = __webpack_public_path__ + "img/la_3d.a6edd97c.png";